module.exports = "<div [chart]=\"chart\"></div>\r\n"